<template>
  <div>
    <ContactHero />
    <ProcessSection />
    <WhyChooseSection />
    <FraudTypesSection />
    <ClientsSaySection />
    <FaqSection />
  </div>
</template>

<script>
import ClientsSaySection from '@/components/HelpCenter/SectionFive/ClientsSaySection.vue';
import FraudTypesSection from '@/components/HelpCenter/SectionFour/FraudTypesSection.vue';
import ContactHero from '@/components/HelpCenter/SectionOne/ContactHero.vue';
import FaqSection from '@/components/HelpCenter/SectionSix/FaqSection.vue';
import WhyChooseSection from '@/components/HelpCenter/SectionThree/WhyChooseSection.vue';
import ProcessSection from '@/components/HelpCenter/SectionTwo/ProcessSection.vue';

export default {
  name: 'HelpCenter',
  components: {
    ContactHero, ProcessSection, WhyChooseSection, FraudTypesSection, ClientsSaySection, FaqSection
  }
}
</script>

<style></style>